/**
 * Fahndungsstufen – einzige Frontend-Quelle für Stufenname/Behörde (NT-FAHNDUNG-02, Teil A).
 *
 * Die interne Stufenzahl (0–5) bleibt in Logik und API unverändert, hier wird nur die
 * Darstellung festgelegt. FL0 ist ein Zustand (SAUBER), keine Behörde.
 *
 * Schwellen spiegeln WANTED_THRESHOLDS aus apps/backend/src/modules/crime/police.service.ts —
 * kein Shared-Import möglich, Werte bei Änderungen dort synchron halten.
 */

export const WANTED_LEVEL_LABELS = [
  'SAUBER',
  'ORDNUNGSAMT',
  'STREIFE',
  'KRIPO',
  'LKA',
  'SEK',
] as const;

export const WANTED_THRESHOLDS = [0, 100, 200, 300, 400, 500] as const;

export const MAX_WANTED_LEVEL = WANTED_LEVEL_LABELS.length - 1;

function clampLevel(level: number): number {
  return Math.min(MAX_WANTED_LEVEL, Math.max(0, Math.floor(level)));
}

/** Stufenname, z. B. 3 → "KRIPO". */
export function getWantedLevelLabel(level: number): string {
  return WANTED_LEVEL_LABELS[clampLevel(level)] ?? WANTED_LEVEL_LABELS[0];
}

/** Anzeige ohne umgebenden FAHNDUNG-Kontext, z. B. 3 → "FAHNDUNG: KRIPO". */
export function formatWantedLevel(level: number): string {
  return `FAHNDUNG: ${getWantedLevelLabel(level)}`;
}

/**
 * Farbiges Stufen-Label (Klassen .wanted-N / .wanted-pulse aus community.css) — gemeinsam
 * genutzt von Rangliste und Steckbrief, ab Stufe 3 pulsierend.
 */
export function renderWantedLevelHtml(level: number): string {
  const lvl = clampLevel(level);
  const pulseClass = lvl >= 3 ? ' wanted-pulse' : '';
  return `<span class="wanted-level wanted-${String(lvl)}${pulseClass}">${getWantedLevelLabel(lvl)}</span>`;
}

/** Punkteschwelle der nächsten Stufe, null auf der Höchststufe. */
export function getNextWantedThreshold(level: number): number | null {
  const lvl = clampLevel(level);
  return lvl >= MAX_WANTED_LEVEL ? null : WANTED_THRESHOLDS[lvl + 1] ?? null;
}
